// src/components/dashboard/customStudy/DeckSelector.tsx
// REFATORADO: Verde Militar + Ícones Lucide + Caixinhas Menores

import React from 'react';
import { Cycle } from '../types';
import { CustomStudyDeck } from './types';
import { Layers, Check } from 'lucide-react';

interface DeckSelectorProps {
    decks: CustomStudyDeck[];
    selectedDeckIds: string[];
    cycles: Cycle[];
    onToggle: (deckId: string) => void;
    loading: boolean;
}

const DeckSelector: React.FC<DeckSelectorProps> = ({
    decks,
    selectedDeckIds,
    cycles,
    onToggle,
    loading
}) => {
    const getCycleName = (cycleId: string) => {
        const cycle = cycles.find(c => c._id === cycleId);
        return cycle?.name || 'Desconhecido';
    };

    React.useEffect(() => {
        console.log('🔍 DeckSelector - Decks recebidos:', decks);
        console.log('🔍 DeckSelector - Cycles disponíveis:', cycles);
    }, [decks, cycles]);

    if (loading) {
        return (
            <div className="selector-section">
                <div className="selector-loading">
                    <div className="spinner"></div>
                    <p>Carregando decks...</p>
                </div>
            </div>
        );
    }

    if (decks.length === 0) {
        return (
            <div className="selector-section">
                <div className="selector-empty">
                    <p>Nenhum deck encontrado nos campos selecionados</p>
                </div>
            </div>
        );
    }

    return (
        <div className="selector-section">
            <div className="selector-header">
                <h3>
                    <Layers size={22} style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '10px' }} />
                    Passo 2: Selecione os Decks
                </h3>
                <span className="selection-count">
                    {selectedDeckIds.length} selecionado{selectedDeckIds.length !== 1 ? 's' : ''}
                </span>
            </div>

            {/* Grid com caixinhas MENORES */}
            <div className="selector-grid-compact">
                {decks.map(deck => {
                    const isSelected = selectedDeckIds.includes(deck._id);
                    const cycleName = getCycleName(deck.cycleId);

                    return (
                        <button
                            key={deck._id}
                            className={`selector-card-compact ${isSelected ? 'selected' : ''}`}
                            onClick={() => onToggle(deck._id)}
                        >
                            <div className="selector-checkbox-compact">
                                {isSelected && <Check size={14} />}
                            </div>
                            <div className="deck-compact-content">
                                <h4 className="deck-compact-name">{deck.name}</h4>
                                <span className="deck-compact-hierarchy">{cycleName}</span>
                                <span className="deck-compact-stat">
                                    {deck.subdeckCount || 0} subdeck{deck.subdeckCount !== 1 ? 's' : ''}
                                </span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DeckSelector;